import React from 'react';

// 'sm' stacks two of these to the care-period ring's exact height in the patient-file header.
const SIZE = {
  md: { fontSize: 11, padding: '2px 8px' },
  sm: { fontSize: 10, lineHeight: '14px', padding: '3px 8px' },
};

export default function CarePeriodStatusBadge({ carePeriod, style, size = 'md' }) {
  if (!carePeriod) return null;
  const status = carePeriod.status || 'unknown';
  const MAP = {
    pending_eligibility: { label: 'Pending eligibility', bg: 'var(--wi-background-moderate)', color: 'var(--wi-text-primary-moderate)' },
    pending_alignment:   { label: 'Pending alignment',   bg: 'var(--wi-background-moderate)', color: 'var(--wi-text-primary-moderate)' },
    ineligible:          { label: 'Ineligible',          bg: 'var(--wi-background-bad)',      color: 'var(--wi-status-bad)' },
    pending_unalignment: { label: 'Pending unalignment', bg: 'var(--wi-background-moderate)', color: 'var(--wi-text-primary-moderate)' },
    active:              { label: 'CMS Aligned',         bg: 'var(--wi-background-good)',     color: 'var(--wi-text-primary-good)' },
    unaligned:           { label: 'CMS Unaligned',       bg: 'var(--wi-background-bad)',      color: 'var(--wi-status-bad)' },
    cancelled:           { label: 'Cancelled',            bg: 'var(--wi-background-tertiary)', color: 'var(--wi-text-secondary)' },
  };
  const cfg = MAP[status] || { label: status, bg: 'var(--wi-background-tertiary)', color: 'var(--wi-text-secondary)' };
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      fontWeight: 600, borderRadius: 20, ...SIZE[size],
      background: cfg.bg, color: cfg.color,
      textTransform: 'uppercase', letterSpacing: '0.04em',
      ...(style || {}),
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
